export default __webpack_public_path__ + "media/images/tenant/hero_3-b689bd49073c3054cb377f6af5da6f6f.jpg";